'use client';
import { useResults } from '#pplx/frontend/apps/ask/providers/ResultsContext.js';
export function useRWToken() {
    const { firstResult } = useResults();
    return firstResult?.read_write_token;
}
//# sourceMappingURL=useRWToken.js.map